const JOIN_INFO = 'index/JOIN_INFO' as const;
const SET_JOIN_INFO = 'index/SET_JOIN_INFO' as const;
export const getJoinInfo = () => ({
  type: JOIN_INFO,
});

export const setJoinInfo = (state: JoinState) => ({
  type: SET_JOIN_INFO,
  payload: state,
});

type JoinAction = ReturnType<typeof getJoinInfo> | ReturnType<typeof setJoinInfo>;

export type JoinState = {
  email: string;
};
const initialState: JoinState = {
  email: '',
};

function join(state: JoinState = initialState, action: JoinAction): any {
  switch (action.type) {
    case JOIN_INFO:
      return { ...state };
    case SET_JOIN_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default join;
